// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2vEX6","filesListContainer":"PosDisputesFiles_filesListContainer__y0Fr0","filesButton":"PosDisputesFiles_filesButton__3GvoH"};